/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    DeliveryTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        DeliveryTemplatesService.getDeliveryTemplate($routeParams.id).then((deliveryTemplate: JS5Object) => {
            DeliveryTemplatesService.originalEditData = _.cloneDeep(deliveryTemplate);
            this.editData = deliveryTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewDeliveryTemplate();
        }
        else {
            updateDeliveryTemplate();
        }
    };

    const updateDeliveryTemplate = () => {
        DeliveryTemplatesService.updateDeliveryTemplate(this.editData).then((deliveryTemplate: JS5Object) => {
            DeliveryTemplatesService.originalEditData = _.cloneDeep(deliveryTemplate);
            this.editData = deliveryTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewDeliveryTemplate = () => {
        DeliveryTemplatesService.createDeliveryTemplate(this.editData).then((deliveryTemplate: JS5Object) => {
            $route.updateParams({id: deliveryTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') && _.size(_.get(this.editData, 'name')) && !_.get(this.editData, 'custom'),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(DeliveryTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'DeliveryTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = DeliveryTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Delivery Template',
                        location: '/system/templates/search',
                        params: {tab: 'DeliveryTemplates'}
                    });
                }
                getData();
            } else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Delivery Template',
                    location: '/system/templates/search',
                    params: {tab: 'DeliveryTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        DeliveryTemplatesService.originalEditData = null;
        DeliveryTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            DeliveryTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = DeliveryTemplatesService;
        });
    };
}


angular.module('prism-ui.deliveryTemplates').component('deliveryTemplatesEditView', {
    templateUrl: 'system/deliveryTemplate/editor/delivery-template-edit-template.html',
    controller: DeliveryTemplatesEditViewController,
    bindings: {
    }
});
